<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="AVK"><section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="CONTENTS"><h1 class="chapter1" id="pAqC"><b>CONTENTS</b></h1>
<p class="cct"><span href="#/instructions#aa1" id="bb1" title="Link target outside of Sample"><em>Ebook Instructions</em></span></p>
<p class="cctt" id="pAl"><a href="#/chapter01#AA_1" id="BB_1"><em>Dear Caroline</em></a></p>
<p class="cct1" id="pAGm"><a href="#/chapter02#AA_2" id="BB_2"><b>1. RUSH</b></a></p>
<p class="cct2" id="pAG7"><a href="#/chapter02#AA_2"><em>Less Rush, More Rhythm</em></a></p>
<p class="cct1" id="pAZc"><span href="#/chapter03#AA_3" id="BB_3" title="Link target outside of Sample"><b>2. TECHNOLOGY</b></span></p>
<p class="cct2" id="pAWg"><span href="#/chapter03#AA_3" title="Link target outside of Sample"><em>Less Liking, More Loving</em></span></p>
<p class="cct1" id="pA8D"><span href="#/chapter04#AA_4" id="BB_4" title="Link target outside of Sample"><b>3. NOISE</b></span></p>
<p class="cct2" id="pApA"><span href="#/chapter04#AA_4" title="Link target outside of Sample"><em>Less Noise, More Calm</em></span></p>
<p class="cct1" id="pAG6"><span href="#/chapter05#AA_5" id="BB_5" title="Link target outside of Sample"><b>4. SOCIAL MEDIA</b></span></p>
<p class="cct2" id="pAh"><span href="#/chapter05#AA_5" title="Link target outside of Sample"><em>Less Distraction, More Connection</em></span></p>
<p class="cct1" id="pAg"><span href="#/chapter06#AA_6" id="BB_6" title="Link target outside of Sample"><b>5. REST</b></span></p>
<p class="cct2" id="pAqv"><span href="#/chapter06#AA_6" title="Link target outside of Sample"><em>Less Frenzy, More Soul Rest</em></span></p>
<p class="cct1" id="pAXQ"><span href="#/chapter07#AA_7" id="BB_7" title="Link target outside of Sample"><b>6. WELLNESS</b></span></p>
<p class="cct2" id="pAWm"><span href="#/chapter07#AA_7" title="Link target outside of Sample"><em>Less Fake, More Real</em></span></p>
<p class="cct1" id="pAk6"><span href="#/chapter08#AA_8" id="BB_8" title="Link target outside of Sample"><b>7. FAITH</b></span></p>
<p class="cct2" id="pAzs"><span href="#/chapter08#AA_8" title="Link target outside of Sample"><em>Less Fear, More Community</em></span></p>
<p class="cct1" id="pAdh"><span href="#/chapter09#AA_9" id="BB_9" title="Link target outside of Sample"><b>8. PARENTING</b></span></p>
<p class="cct2" id="pAcQ"><span href="#/chapter09#AA_9" title="Link target outside of Sample"><em>Less Great, More Good</em></span></p>
<p class="cct1" id="pAyM"><span href="#/chapter10#AA_10" id="BB_10" title="Link target outside of Sample"><b>9. CHASING</b></span></p>
<p class="cct2" id="pACd"><span href="#/chapter10#AA_10" title="Link target outside of Sample"><em>Less Chasing, More Cherishing</em></span></p>
<p class="cct1" id="pAE"><span href="#/chapter11#AA_11" id="BB_11" title="Link target outside of Sample"><b>10. HOME</b></span></p>
<p class="cct2" id="pAaM"><span href="#/chapter11#AA_11" title="Link target outside of Sample"><em>Less Stuff, More Treasures</em></span><br/> <br/> </p>
<p class="cct2a" id="pADz"><span href="#/chapter12#AA_12" id="BB_12" title="Link target outside of Sample"><em>Dear Caroline</em></span></p>
<p class="cct2a" id="pAlY"><span href="#/chapter13#AA_13" id="BB_13" title="Link target outside of Sample"><em>Continuing the Journey</em></span></p>
<p class="cct2a" id="pAS8"><span href="#/chapter14#AA_14" id="BB_14" title="Link target outside of Sample"><em>Acknowledgments</em></span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content-toc.vue?693279d0